import styled from 'styled-components';

export const DrawerAdjustment = styled.div`
    padding-left: 72px;
    @media screen and (max-width: 700px) {
        padding-left: 0;
    }
`;
